/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeveloper = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a8 8 0 0 1 5.281 14.01A4.998 4.998 0 0 1 22 21v1H2v-1a5 5 0 0 1 4.719-4.992A8 8 0 0 1 12 2zm5 16H7c-1.302 0-2.41.83-2.825 1.988L4.17 20h15.659l-.076-.193a3.002 3.002 0 0 0-2.577-1.802zM12 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM9.293 7.293l1.414 1.414L9.415 10l1.292 1.293-1.414 1.414L6.586 10zm5.414 0L17.414 10l-2.707 2.707-1.414-1.414L14.585 10l-1.292-1.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDeveloper as Developer };
